import type { FaireProductEntity } from "../../entity_types/product";

export const p_tq3yf5ybzp: FaireProductEntity = {
  token: "p_tq3yf5ybzp",
  type: "product",
  name: "Christmas Nativity Peg Puzzle",
  brandToken: "b_b2bxmek3gf",
  brandName: "Kingdom Come Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/c738274f02c4838207b682a7b857c83fad735bf9078aa8e7d3d3e88cda04eda6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/714855b408547ce7203d107317f683101505550a51a04e0e781478c903d4edd2.jpeg",
  ],
  priceDollars: 18.01,
  description:
    "Celebrate the true meaning of Christmas with this beautifully illustrated wooden Nativity peg puzzle. Thoughtfully designed for little hands, this timeless puzzle helps children learn and play as they discover the story of Jesus’ birth.\n\nEach sturdy wooden piece reveals a key part of the Nativity scene including Mary, Joseph, Baby Jesus, the shepherds, the angel, the star and the Wise Men, inviting faith-filled conversation and hands-on learning. The verse from Luke 2:11 (“For unto you is born this day in the city of David a Savior, who is Christ the Lord”) is featured on the puzzle, reminding little ones of the joy and hope of the season.\n\nMade with thick, durable wood and child-safe paints, this keepsake puzzle is perfect for Advent learning, Sunday school, or as a meaningful Christmas gift for toddlers and preschoolers.\n\n\n\n✨ Features:\n\n * Beautiful Nativity scene illustration with Bible verse (Luke 2:11) \n * Six easy-grip wooden peg pieces \n * Encourages fine motor skills, faith learning, and storytelling \n * Crafted from smooth, durable wood with non-toxic finish \n * Dimensions: 20.3 × 29.2 cm (8″ × 11.5″) \n * Recommended for ages 3+ \n\n\n\n\nPerfect for:\n\n🎁 Christmas morning surprises\n\n🌟 Advent and Sunday school lessons\n\n💛 Faith-based playrooms and homeschool spaces\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:11.883Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
